import { UserService } from './../../../base-services/user.service';
import { ColumnData } from './../../../base-models/column-data';
import { ControlsContainerDirective } from './controls-container.directive';
import { BaseDataService } from './../../../base-services/base-data.service';
import { BaseEntity } from './../../../base-models/base-entity';
import { List } from 'immutable';
import { ChangeDetectorRef, Input, ViewChild, ComponentFactoryResolver, ViewChildren, QueryList, Output, EventEmitter } from '@angular/core';
import { Component } from '@angular/core';
import { AbstractCustomControl, MakeProvider } from "../../abstract-custom-control";
import { ModelData } from '../../../base-models/model-data';
import { ModelDataService } from '../../../base-services/model-data.service';
import { DropdownPicklistComponent } from '../dropdownPicklist/dropdownPicklist.component';
import { ListData } from '../../../base-models/list-data';

@Component({
    selector: 'cascade-dropdown',
    templateUrl: './cascade-dropdown.component.html',
    providers: [ MakeProvider(CascadeDropdownComponent) ]
})
export class CascadeDropdownComponent<T extends BaseEntity> extends AbstractCustomControl<string> {
    constructor(protected changeDetectorRef: ChangeDetectorRef,
                protected baseDataService: BaseDataService,
                protected modelDataService: ModelDataService,
                protected componentFactoryResolver: ComponentFactoryResolver,
                protected userService: UserService){
        super(changeDetectorRef);
    }

    items: T[];
    @Input() ModelName: string;
    @Input() GetName: string;
    @Input() ModelProperty: string;
    //@Input() ModelClass: any;
    @Input() set Source(value: T[]){
        this.items = value;
        this._numberOfControls = this.items.length;
        this.createControls(this.items);
    }
    @Input() set NumberOfControls(value: number){
        //this._numberOfControls = value;
        //this.createControls();
    }

    @Output() OnItemSelected = new EventEmitter();

    private _modelData: ModelData;
    private _dropdown1SelectedItem: T;
    private _dropdown2SelectedItem: T;
    private _dropdown3SelectedItem: T;
    private _numberOfControls: number = 0;
    private _controls: DropdownPicklistComponent<T>[] = [];
    private _values: T[] = [];

    @ViewChild('dropdown1', { static: false }) dropdown1: DropdownPicklistComponent<T>;
    @ViewChild('dropdown2', { static: false }) dropdown2: DropdownPicklistComponent<T>;
    @ViewChild('dropdown3', { static: false }) dropdown3: DropdownPicklistComponent<T>;

    @ViewChild(ControlsContainerDirective, { static: true }) controlsContainer: ControlsContainerDirective;
    //@ViewChildren(DropdownPicklistComponent) _controls: QueryList<DropdownPicklistComponent<T>>;

    ngOnInit(){
        if(this.ModelName && this.ModelName != '')
            this._modelData = this.modelDataService.GetModelDataByPath(this.ModelName);
        this.loadItems();
    }

    private loadItems(){
        if(this.ModelName && this.GetName){
            this.baseDataService.Get(this.ModelName, this.GetName, null, this._modelData.MainList.ModelClass)
                .subscribe((data: T[]) => {
                    this.items = data;
                    //this.dropdown1.Source = data;
                    this.createControls(data);
                })
        }
    }

    ngAfterViewInit(){
        //this.dropdown2.disabled = true;
        //this.dropdown3.disabled = true;
    }

    dropdown1Selected(selectedItem){
        this._dropdown1SelectedItem = selectedItem;
        this.dropdown2.Source = [];
        this.dropdown3.Source = [];
        this.dropdown3.disabled = true;
        this.dropdown2.disabled = true;
        this.dropdown2.Clear();
        this.dropdown3.Clear();
        if(this._dropdown1SelectedItem){
            this.dropdown2.Source = this.items.filter(item => item != selectedItem);
            this.dropdown2.disabled = false;
            this.value = this._dropdown1SelectedItem[this.ModelProperty];
        }
        this.changeDetectorRef.markForCheck();
    }

    dropdown2Selected(selectedItem){
        this._dropdown2SelectedItem = selectedItem;
        this.dropdown3.Source = [];
        this.dropdown3.disabled = true;
        this.dropdown3.Clear();
        if(this._dropdown1SelectedItem && this._dropdown2SelectedItem){
            this.dropdown3.Source = this.items.filter(item => item != this._dropdown1SelectedItem && item != this._dropdown2SelectedItem);
            this.dropdown3.disabled = false;
            this.value = this._dropdown1SelectedItem[this.ModelProperty] + ',' + this._dropdown2SelectedItem[this.ModelProperty];
        }
    }

    dropdown3Selected(selectedItem){
        this._dropdown3SelectedItem = selectedItem;
        if(this._dropdown3SelectedItem){
            this.value = this._dropdown1SelectedItem[this.ModelProperty] + ',' + this._dropdown2SelectedItem[this.ModelProperty] + ',' + this._dropdown3SelectedItem[this.ModelProperty];
        }
    }

    private createControls(items){
        this.controlsContainer.viewContainerRef.clear();
        for(let i = 0; i < this._numberOfControls; i++){
            let componentFactory = this.componentFactoryResolver.resolveComponentFactory(DropdownPicklistComponent);
            
            let componentRef = this.controlsContainer.viewContainerRef.createComponent(componentFactory);
            (<DropdownPicklistComponent<T>>componentRef.instance).ModelName = this.ModelName;
            (<DropdownPicklistComponent<T>>componentRef.instance).ModelProperty = this.ModelProperty;
            (<DropdownPicklistComponent<T>>componentRef.instance).disabled = true;
            (<DropdownPicklistComponent<T>>componentRef.instance).Name = i.toString();
            //(<DropdownPicklistComponent<T>>componentRef.instance).Label = this.Label;
            (<DropdownPicklistComponent<T>>componentRef.instance).Index = (i + 1).toString();
            (<DropdownPicklistComponent<T>>componentRef.instance).Required = false;
            if(i == 0){
                (<DropdownPicklistComponent<T>>componentRef.instance).Source = items;
                (<DropdownPicklistComponent<T>>componentRef.instance).disabled = false;
            }
            (<DropdownPicklistComponent<T>>componentRef.instance).OnItemSelected.subscribe(item => {
                this.itemSelected(item, componentRef.instance.Name);
            })

            this._controls.push((<DropdownPicklistComponent<T>>componentRef.instance));
        }
    }

    private itemSelected(item, dropdownName){
        //this._controls.forEach(dropdownComponent => {
            //dropdownComponent.disabled = false;
        //})
        let index = parseInt(dropdownName);
        this._values[index] = item;

        this._controls.forEach(dropdownControl => {
            if(parseInt(dropdownControl.Name) > index)
                this.disableControl(dropdownControl);
        })

        let nextIndex = index < this._controls.length - 1 ? index + 1 : -1;
        if(nextIndex > -1){
            let nextDropdownComponent = this._controls.find(dropdownComponent => dropdownComponent.Name == (nextIndex.toString()));
            nextDropdownComponent.disabled = false;
            nextDropdownComponent.Source = this.items.filter(dropdownItem => this._values.indexOf(dropdownItem) == -1);
        }

        this.value = '';
        //this.value = '';
        this._values.forEach(value => {
            this.value += value != null ? value['ID'] + ',' : '';
        })
        this.value = this.value.substring(0, this.value.length - 1);
        this.OnItemSelected.emit(this.value);
        //let founded: boolean = false;
        //this._controls.forEach((dropdown: DropdownPicklistComponent<T>) => {
            //if(dropdownName == dropdown.dropDownName)
                //founded = true;

            //if(founded){
                //dropdown.Source = this.items.filter(dropdownItem => dropdownItem != item);
                //dropdown.disabled = false;
            //}
        //})
    }

    private disableControl(dropdownControl: DropdownPicklistComponent<T>){
        dropdownControl.Source = [];
        dropdownControl.disabled = true;
        dropdownControl.Clear();
    }
}